import { Outlet } from "react-router-dom";
import AuthLayout from "@/app/components/auth/AuthLayout";

export default function AuthLayoutRoute() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
